var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',[_c('base-header',{attrs:{"title":"Seleccionar grupo","title-link":_vm.titleLink,"map":[
        'Mercado Libre',
        'Atributos',
        'Grupos',
        _vm.attributeGroupIntegrationConfigName
      ],"title-size":12}}),(_vm.loading)?_c('b-spinner',{attrs:{"label":"Spinning"}}):_c('mercado-libre-attributes-table',{attrs:{"attribute-group-integration-config":_vm.attributeGroupIntegrationConfig}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }